import Tippy from "@tippyjs/react";
import SpaceChatMsg from "components/Home/VideoBarContainer/VideoBar/SpaceSideContainer/SpaceSideBar/SpaceMcht/SpaceChatMsg/SpaceChatMsg";
import { NOTIFICATION_TIME } from "constants/constants";
import React, { useState, useEffect, forwardRef, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setSpaceSidebar,
  SPACE_CHAT,
  selectSpaceBoxActive,
  toggleSpaceBox,
} from "slices/spaceMediaSlice";
import { selectChatHistory, selectNewChat } from "slices/spaceSlice";
import { animateFill } from "tippy.js";
import "tippy.js/dist/tippy.css";

const NotifierTippy = forwardRef(({ children, ...rest }, ref) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const latestChat = useSelector((state) => selectChatHistory(state)[0]);
  const newChat = useSelector(selectNewChat);
  const spaceBoxActive = useSelector(selectSpaceBoxActive);
  const didMount = useRef(null);

  useEffect(() => {
    let timer = null;
    if (newChat && didMount.current) {
      setOpen(true);
      timer = setTimeout(() => {
        setOpen(false);
      }, NOTIFICATION_TIME);
    }
    return () => {
      didMount.current = true;
      clearTimeout(timer);
      setOpen(false);
    };
  }, [newChat, latestChat]);

  return (
    <Tippy
      animateFill={true}
      plugins={[animateFill]}
      animation="shift-away"
      popperOptions={{
        modifiers: [
          {
            name: "preventOverflow",
            options: {
              altAxis: true,
              tether: false,
            },
          },
        ],
      }}
      appendTo={document.getElementById("space-and-video")}
      content={
        <div
          // className="space-notifier"
          onClick={() => {
            if (!spaceBoxActive) toggleSpaceBox();
            dispatch(setSpaceSidebar(SPACE_CHAT));
          }}
        >
          {latestChat && (
            <SpaceChatMsg
              name={latestChat.name}
              time={latestChat.time}
              text={latestChat.text}
            />
          )}
        </div>
      }
      placement="top"
      className="notifier-Tippy content-only-Tippy"
      visible={open}
      arrow
      interactive
      {...rest}
    >
      {React.cloneElement(children, { ref: ref })}
    </Tippy>
  );
});

export default NotifierTippy;
